// src/Redux/orderSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderType: "", // 'takeaway' or 'dinein'
  table: null,
  items: [],
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setTable: (state, action) => {
      state.table = action.payload;
    },
    addItem: (state, action) => {
      state.items.push(action.payload);
    },
    updateItem: (state, action) => {
      const { index, updatedItem } = action.payload;
      state.items[index] = updatedItem;
    },
    removeItem: (state, action) => {
      state.items.splice(action.payload, 1);
    },
    clearOrder: (state) => {
      state.items = [];
    },
    sendToKOT: (state) => {
      // Add any real-time sending logic here
      console.log("Order sent to KOT:", state.items);
    },
    generateBill: (state) => {
      // Simulate generating a bill
      const total = state.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      console.log("Bill Generated for:", state.items);
      console.log("Total Amount:", total);
    },
    resetOrder: (state) => {
      state.orderType = "";
      state.table = null;
      state.items = [];
    },
  },
});

export const {
  setOrderType,
  setTable,
  addItem,
  updateItem,
  removeItem,
  clearOrder,
  sendToKOT,
  generateBill,
  resetOrder,
} = orderSlice.actions;

export default orderSlice.reducer;
